import {
  CellProps,
  isDateControl,
  RankedTester,
  rankWith,
} from "@jsonforms/core";
import { withJsonFormsCellProps } from "@jsonforms/react";

import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/utils";
import { VanillaRendererProps } from "@jsonforms/vanilla-renderers";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";

export const DateCell = (props: CellProps & VanillaRendererProps) => {
  const { data: date, enabled, path, handleChange } = props;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          disabled={!enabled}
          variant={"outline"}
          className={cn(
            "w-full justify-start text-left font-normal",
            !date && "text-muted-foreground",
          )}
        >
          <CalendarIcon />
          {date ? format(new Date(date), "PPP") : <span>Pick a date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar
          mode="single"
          selected={date}
          onSelect={(date) => {
            return handleChange(
              path,
              date ? format(date, "yyyy-MM-dd") : undefined,
            );
          }}
          autoFocus
        />
      </PopoverContent>
    </Popover>
  );
};

export const dateCellTester: RankedTester = rankWith(3, isDateControl);

export default withJsonFormsCellProps(DateCell);
